import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class UpdatedTermsAndConditionsConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isExtended(): boolean {
		return this.configService.get((x) => x.commonUi?.updatedTermsAndConditions?.isExtended, false);
	}
}
